var _path, _path2, _path3, _polygon, _rect, _path4, _path5, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _path6, _path7, _path8, _polygon22, _polygon23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentstressRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.52,230.72c-68.39-16.87-89.69-161.28-192.92-80.1-73.24,57.6-32,193.54,58.74,175.74,54.92-10.78,46.49-11.6,92.31,13.48,46.43,25.41,97.88,37.58,149.06-10.22C429.2,304.88,440.64,245.7,416,215.7,385.27,178.18,337.3,241,295.52,230.72Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.52,230.72c-68.39-16.87-89.69-161.28-192.92-80.1-73.24,57.6-32,193.54,58.74,175.74,54.92-10.78,46.49-11.6,92.31,13.48,46.43,25.41,97.88,37.58,149.06-10.22C429.2,304.88,440.64,245.7,416,215.7,385.27,178.18,337.3,241,295.52,230.72Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-7",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259,99.35H213.37A15.68,15.68,0,0,0,197.69,115v44.3A15.67,15.67,0,0,0,213.37,175h30.12l10.81,16.55V175H259a15.66,15.66,0,0,0,15.67-15.67V115A15.67,15.67,0,0,0,259,99.35Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,99.35H213.37A15.68,15.68,0,0,0,197.69,115v44.3A15.67,15.67,0,0,0,213.37,175h30.12l10.81,16.55V175H259a15.66,15.66,0,0,0,15.67-15.67V115A15.67,15.67,0,0,0,259,99.35Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.36,165.86A24.27,24.27,0,0,1,221,163.4c-4.37-2.08-7.29-5.09-8.22-8.4-.34-.16-.68-.34-1-.53a14.34,14.34,0,0,1-6.39-10A29.11,29.11,0,0,1,208,127.29a16,16,0,0,1-.24-4c.28-4.72,2.63-8.94,6.14-11a10,10,0,0,1,7.53-1,25.87,25.87,0,0,1,12.49-4.41,19.19,19.19,0,0,1,12.41,3.45,13.25,13.25,0,0,1,11.88,2.33,14.78,14.78,0,0,1,5,9.19,18.54,18.54,0,0,1-.05,5.41A17.6,17.6,0,0,1,267,141.69a17.94,17.94,0,0,1-7.08,10.38,7.22,7.22,0,0,1,.53,3.16c-.26,3.57-3.25,6.17-6.1,7.16a18.34,18.34,0,0,1-9.27.24,12.84,12.84,0,0,1-7.13,2h0A17.67,17.67,0,0,1,231.36,165.86Zm-17.13-10.28c1.49,3.63,5.44,5.87,7.28,6.74,5.57,2.65,11.45,3.07,16,1.21a.11.11,0,0,1,.08,0c.4-.17.79-.35,1.17-.55a16.72,16.72,0,0,0,2.15-1.39,12.4,12.4,0,0,1-4-2.32,10.3,10.3,0,0,1-1.3-1.41,27.45,27.45,0,0,1-8.89-1.57,19.83,19.83,0,0,1-1.87-.8A19.26,19.26,0,0,1,214.23,155.58ZM242.29,162a15.93,15.93,0,0,1-1.58,1.19,10.23,10.23,0,0,0,2.66-.91Zm4-.38a16.06,16.06,0,0,0,7.66-.36c2.48-.86,5.09-3.09,5.3-6.12a5.65,5.65,0,0,0-.34-2.36,24.45,24.45,0,0,1-2.29,1.33,31,31,0,0,1-7.77,2.62A9.59,9.59,0,0,1,246.28,161.62Zm-2.94-.58c.5.12,1,.23,1.45.32a8.13,8.13,0,0,0,2.76-4.38l-1,.17A24.35,24.35,0,0,1,243.34,161Zm-6.15-3.19c.17.17.34.34.52.5a11.75,11.75,0,0,0,4.3,2.31,21.57,21.57,0,0,0,2.9-3.3c-1.48.18-2.9.29-4.22.37C239.57,157.79,238.4,157.84,237.19,157.85Zm-1-1.2c1.52,0,3,0,4.4-.12,1.6-.09,3.36-.23,5.2-.49.53-.83,1.05-1.72,1.56-2.68l.43-.83a18.3,18.3,0,0,0-1.37-4.64,23.94,23.94,0,0,1-6.31,1.53c-1.91.72-3.78,1.55-5.63,2.36l-.32.15A14.73,14.73,0,0,0,236.22,156.65Zm-9.6-1.71.52.2a25.39,25.39,0,0,0,7.63,1.46,16.83,16.83,0,0,1-1.7-4.19A69,69,0,0,1,226.62,154.94Zm21.27,0c-.17.3-.34.6-.51.88l.43-.07a1,1,0,0,1,0-.17C247.86,155.34,247.88,155.13,247.89,154.91Zm1.15-2.17a12.46,12.46,0,0,1,0,2.73,29.77,29.77,0,0,0,7-2.43,21.07,21.07,0,0,0,2.32-1.36,8.12,8.12,0,0,0-3.39-3.19,11.06,11.06,0,0,0-3.74-1.05A50.24,50.24,0,0,1,249,152.74Zm-35.24,1.4a16.33,16.33,0,0,0,9.5.46,13.59,13.59,0,0,1-6.5-9.75c-1.91,2.72-3.45,5.55-3.1,8.64A4.63,4.63,0,0,0,213.8,154.14Zm4-10.71A12.73,12.73,0,0,0,225,154.18a59.87,59.87,0,0,0,7.81-3c-.16-.75-.29-1.52-.38-2.29a21.55,21.55,0,0,1-4.16-1.44c-1.83-.87-6.11-3.35-6.26-7.62v-.42c-.41,0-.83,0-1.25,0-.58.86-1.21,1.73-1.87,2.62l-.37.49Zm-9.38-14.22a27.46,27.46,0,0,0-1.9,15.06,13.31,13.31,0,0,0,5.84,9.17l.1.06c-.38-3.94,1.92-7.46,4.25-10.6h0l.8-1.07.37-.49c.52-.69,1-1.38,1.49-2.06a13.18,13.18,0,0,1-6-2.67A15.13,15.13,0,0,1,208.45,129.21Zm43.2,17.07a12,12,0,0,1,3.88,1.14,9.39,9.39,0,0,1,3.84,3.56,16.68,16.68,0,0,0,6.45-9.54,16.17,16.17,0,0,0-3-12.6,25.5,25.5,0,0,1-2.19,5.89,28.59,28.59,0,0,1-8.51,10C252,145.27,251.81,145.78,251.65,146.28Zm-18,2.92c.07.51.16,1,.26,1.54l.11-.05,2.66-1.16A25.52,25.52,0,0,1,233.65,149.2Zm13.91-1.72a21.75,21.75,0,0,1,1.11,3.23c.49-1.1.94-2.22,1.35-3.35A19.09,19.09,0,0,0,247.56,147.48Zm-14,.48a22.32,22.32,0,0,0,6.33.29,36.23,36.23,0,0,1,6-1.71,30.25,30.25,0,0,0-3-4.68,18.55,18.55,0,0,1-9.23.78A25.57,25.57,0,0,0,233.52,148Zm-10.32-8.59a3.65,3.65,0,0,0,0,.47c.13,3.71,4.3,6,5.58,6.57a19,19,0,0,0,3.52,1.27,27.43,27.43,0,0,1,.15-5.28,17.47,17.47,0,0,1-3.63-1.3,15.29,15.29,0,0,1-3.37-2.23A12.29,12.29,0,0,1,223.2,139.37Zm20.8,2a30.47,30.47,0,0,1,3,4.94,24.42,24.42,0,0,0,4-2.31,48.39,48.39,0,0,0,1.47-18.52,33.06,33.06,0,0,0-.84-4.65,39.19,39.19,0,0,0-9-2,38.49,38.49,0,0,0-4-.23,54.33,54.33,0,0,0-2.71,6.62l-.14.38a39.08,39.08,0,0,1-3.14,7,13.85,13.85,0,0,1,2.46.86l.36-.66a13.42,13.42,0,0,1,5.7-6,7.19,7.19,0,0,1,8.14,1,7,7,0,0,1,1.11,7.62,11.78,11.78,0,0,1-5.5,5.42C244.66,141.1,244.33,141.26,244,141.4Zm6,4.76h.45c0-.11.07-.23.11-.35C250.36,145.94,250.17,146.05,250,146.16Zm3.08-24.77a34.35,34.35,0,0,1,.67,4,49.72,49.72,0,0,1-1.11,17.49,27.54,27.54,0,0,0,6.93-8.68,23.58,23.58,0,0,0,2.3-6.57,18.78,18.78,0,0,0-2.22-2.24A24.88,24.88,0,0,0,253.06,121.39Zm-19.27,20.07a17.31,17.31,0,0,0,8.27-.6,33.26,33.26,0,0,0-3.89-4,16.19,16.19,0,0,0-2.45-1.74A25.39,25.39,0,0,0,233.79,141.46Zm-7.08-3.08a14.82,14.82,0,0,0,2.63,1.65,16.06,16.06,0,0,0,3.28,1.18,26.85,26.85,0,0,1,2-6.62,11.34,11.34,0,0,0-2.64-.87,13.89,13.89,0,0,1-4.45,4.21C227.28,138.09,227,138.24,226.71,138.38Zm9.53-4.32a16.61,16.61,0,0,1,2.7,1.91,33.5,33.5,0,0,1,4.3,4.45,12.82,12.82,0,0,0,1.19-.55,10.53,10.53,0,0,0,4.95-4.83,5.82,5.82,0,0,0-.86-6.3c-1.77-1.79-4.75-1.74-6.77-.77a12.3,12.3,0,0,0-5.18,5.46Zm-14.72,4.21c.21,0,.42,0,.63,0a6.46,6.46,0,0,1,.91-2.12l-.12-.18C222.5,136.72,222,137.49,221.52,138.27Zm-12.29-10.84a14.14,14.14,0,0,0,4.89,8.23,12.12,12.12,0,0,0,6,2.52c.78-1.18,1.49-2.33,2.12-3.46a10.13,10.13,0,0,1-.78-2.49c-.71-4.11,1.34-8.53,5.1-11.35A9.41,9.41,0,0,0,225,115a6.88,6.88,0,0,0-3.39-2.38c-.94.64-1.79,1.3-2.54,1.92A38.52,38.52,0,0,0,209.23,127.43Zm14.6,9.78a5.81,5.81,0,0,0-.4.92c.35,0,.69-.13,1-.21C224.23,137.69,224,137.45,223.83,137.21Zm.7-1a12.32,12.32,0,0,0,1.19,1.33,10.22,10.22,0,0,0,1.25-.6,12.53,12.53,0,0,0,3.68-3.35,8.13,8.13,0,0,0-1.64.08A7.44,7.44,0,0,0,224.53,136.17Zm-.91-1.42.22.38a8.63,8.63,0,0,1,5-2.69,9.82,9.82,0,0,1,2.6,0,36.32,36.32,0,0,0,3.29-7.18l.13-.39a66.37,66.37,0,0,1,2.48-6.18,19.15,19.15,0,0,0-8.38,2.12,10.65,10.65,0,0,0-1.19.74c0,.54-.09,1.11-.17,1.69A33.4,33.4,0,0,1,223.62,134.75Zm2.86-12.2c-2.59,2.35-4.44,5.85-3.81,9.48a8.83,8.83,0,0,0,.34,1.32,31.91,31.91,0,0,0,3.41-10.29ZM252.69,120a26.25,26.25,0,0,1,7.71,4.5,23,23,0,0,1,1.67,1.59,16.82,16.82,0,0,0-.08-4,13.59,13.59,0,0,0-4.55-8.44,12,12,0,0,0-9.95-2.32,15.41,15.41,0,0,1,1.93,2A19,19,0,0,1,252.69,120Zm-33.81-7.8a8.67,8.67,0,0,0-4.38,1.17c-3.17,1.87-5.3,5.72-5.56,10.06a14.1,14.1,0,0,0,0,2,39.72,39.72,0,0,1,9.37-11.74c.54-.44,1.12-.9,1.75-1.36A7.84,7.84,0,0,0,218.88,112.16Zm4-.35a7.7,7.7,0,0,1,3.12,2.46,10.11,10.11,0,0,1,1.81,5.81c.19-.12.39-.23.6-.34a21,21,0,0,1,9.59-2.29,16.23,16.23,0,0,1,4.2-5.06,12.17,12.17,0,0,1,2.73-1.57A18.11,18.11,0,0,0,234,108.08,24.29,24.29,0,0,0,222.86,111.81Zm16.51,5.64c1.12,0,2.28.1,3.5.23a41.74,41.74,0,0,1,8.42,1.77,17.29,17.29,0,0,0-2.81-5.41,13.86,13.86,0,0,0-2.4-2.38,10.62,10.62,0,0,0-3.17,1.68A14.26,14.26,0,0,0,239.37,117.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.28,314.91c-25-6-53.74-19.45-67.93-42a21.59,21.59,0,0,1-2.76-5.94c-5.56-22.19,25.08-35.27,41.35-41.58a167.56,167.56,0,0,1,17.73-5.59l4.16,11.27c-10,5.47-39.43,20.9-42.57,30.68.11,0,.16-.6.1-1a1.5,1.5,0,0,0-.06-.33s0,0,0-.06c12.16,16.12,34.63,24.78,53.53,30.41l1.74.48-5.3,23.65Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,329.29l-6.27-3.76-3.87-2.32-31.13-18.65,6.31-33.16s18.2,11.16,27.53,14.32c0,0,5.71,5.36,7.58,16.16a39.57,39.57,0,0,1,.55,5.12c0,1,.08,2,.1,3A115.77,115.77,0,0,1,286.85,329.29Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,329.29l-6.27-3.76c1.21-6,4.39-11.63,7.07-15.56A115.77,115.77,0,0,1,286.85,329.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.35,201a.26.26,0,0,1-.25-.22s-.71-5.26-4.14-7.22a.26.26,0,0,1-.09-.34.25.25,0,0,1,.34-.09c3.65,2.08,4.36,7.36,4.39,7.59a.26.26,0,0,1-.22.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,397.44a407,407,0,0,0-5.47-80.53c-1.05-6.25-2.17-12-3.28-17.09a258.83,258.83,0,0,0-7.93-29.61s-27.63,20-49.77,20a156.85,156.85,0,0,1-37.08-4.53c8.41,40.15,9.74,88.24,9.83,111.72Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.16,226.37l-.53-18.43,16.92,5.24s-2.27,17.36-7.73,17.74Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.67 196.67 293.48 203.37 287.55 213.18 270.63 207.94 282.67 196.67",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.23,281.89c2.31-1.91,26.3-8.39,29.43-7.35s-9.21,23.57-21.21,19.42S304.54,284.1,307.23,281.89Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.76,279.94s-.38,9.8-20.07,15a23.25,23.25,0,0,0-4.47,7,24.75,24.75,0,0,1-2.3-5.58c-18.44,2.94-8.22-8.1-8.22-8.1,6.26-3.19,8.58-7.15,8.79-11.4a18.93,18.93,0,0,0-1.24-7.13,43.4,43.4,0,0,0-2.08-5l2.91-3.92,15.1-14.52a107.25,107.25,0,0,0,1.57,13.58C330.39,268.53,333.4,276.72,338.76,279.94Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.75,259.85c-2.87,6.76-9.56,13.31-16.26,17a18.93,18.93,0,0,0-1.24-7.13,43.4,43.4,0,0,0-2.08-5l2.91-3.92,15.1-14.52A107.25,107.25,0,0,0,328.75,259.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.69,294.9l8.16,8s16.71-8.69,19.84-21.86l-10-6.49S333.39,287.06,318.69,294.9Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.92,296.34,301.59,306s-3.58-9.87-2.52-17.31l8.16-6.83S306.51,290.49,311.92,296.34Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.69,294.9l8.16,8s16.71-8.69,19.84-21.86l-10-6.49S333.39,287.06,318.69,294.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.92,296.34,301.59,306s-3.58-9.87-2.52-17.31l8.16-6.83S306.51,290.49,311.92,296.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,216.52c-6.79,5.37-5.67,28,5.23,30.19S301.5,206.36,288.65,216.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.37,231.12c.49,15.91,1.58,25.17-5.62,34.28-10.82,13.7-30.88,8.94-36.08-6.34-4.68-13.76-4.69-37.47,10.12-45.7C312.38,205.24,328.89,215.21,329.37,231.12Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.76,223.3c-1.64,9.09,4.49,21.24,9.46,22.35,6,2.84,13.23-7.62,14.23-13,.89-4.81-.45-15.27-3.55-19.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,246a17.07,17.07,0,0,1-8.15,8.09c-4.56,2-6.73-2.15-5.38-7,1.22-4.37,5.06-10.69,9.59-10.63S338.94,241.52,336.78,246Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,240.45s-2.23,7.79-5.1,11.77c2.46,1.84,6.22.38,6.22.38Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.23,230.9a.7.7,0,0,0-.33.19.77.77,0,0,0,0,1.07,7.25,7.25,0,0,0,6.48,2.2.73.73,0,0,0,.57-.9.75.75,0,0,0-.9-.57A5.79,5.79,0,0,1,305,231.1.78.78,0,0,0,304.23,230.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,231a.74.74,0,0,0-.64.31,6.31,6.31,0,0,1-4.85,2.79.76.76,0,0,0,0,1.52h0a7.83,7.83,0,0,0,6.11-3.42.75.75,0,0,0-.59-1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,239.93a.38.38,0,0,1-.28-.12c-.47-.52-2-.52-2.9-.4a.38.38,0,0,1-.39-.2.37.37,0,0,1,.06-.42,4.41,4.41,0,0,1,3.32-1.64.38.38,0,0,1,0,.75,3.37,3.37,0,0,0-2,.69,3.46,3.46,0,0,1,2.47.72.37.37,0,0,1,0,.52A.35.35,0,0,1,308,239.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.51,242a.41.41,0,0,1-.19-.05.38.38,0,0,1-.14-.51,3.48,3.48,0,0,1,2.26-1.21,3.34,3.34,0,0,0-2.05-.27.39.39,0,0,1-.46-.27.38.38,0,0,1,.27-.46,4.42,4.42,0,0,1,3.59.92.36.36,0,0,1,.13.4.37.37,0,0,1-.33.28c-.88.06-2.41.38-2.76,1A.37.37,0,0,1,288.51,242Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,255.19h0a3,3,0,0,1-2.48,2.6,50.13,50.13,0,0,0-9,3.89l-.08-.14v0a11.71,11.71,0,0,0-2.49-3.24,1.59,1.59,0,0,0-.54-.29l0-.06c.47-.64,4.7-6.25,11.46-5.92a3.4,3.4,0,0,1,2,.69A2.88,2.88,0,0,1,313.67,255.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.11,257.93l.5.35a1.59,1.59,0,0,0-.54-.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.24,254.69a25.73,25.73,0,0,0-4.78,1l.12.81-.48-.69a23,23,0,0,0-3.76,1.63l.28.67-.54-.52a19.3,19.3,0,0,0-2.84,2l.86,1.94a11.71,11.71,0,0,0-2.49-3.24l1.34.92a12,12,0,0,1,2.58-2.1h0l-.47-1.11.89.86a19.21,19.21,0,0,1,3.74-1.69l-.37-1,1,.77a24.36,24.36,0,0,1,4.42-.87l-.24-1.36a2.88,2.88,0,0,1,1.14,2.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.35,229s11.47-14.81-.78-19.66c0,0-3.18-10.6-9.05-13.15s-10.6,3.45-10.6,3.45a12.69,12.69,0,0,0-12.13-7.39c-8.93.36-10.18,7.77-10.18,7.77s-6.86-2.94-12.76,1a6.93,6.93,0,0,0-2.43,9.58s-8.84,4.85-6.16,11,10,3.19,10,3.19-.2,3.45,4.13,3.58,11.34-4.72,11.34-4.72a7.47,7.47,0,0,0,5.89,2.81c4.09.12,7.87-2.69,7.87-2.69a10.78,10.78,0,0,0,6.82,6C329.37,231.12,342.35,229,342.35,229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.06,210l-6.75-17.15-13.5,11.46s8.9,15.07,14.08,13.28Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.82 187.16 321.5 197.57 330.81 204.27 344.31 192.81 328.82 187.16",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.61,203.08h-.05a.24.24,0,0,1-.19-.29,8.65,8.65,0,0,0-3.44-8.29,3.36,3.36,0,0,1-1.66,2.39,1.28,1.28,0,0,1-1.83-.12,2.47,2.47,0,0,1,.18-3c.33-.36,1.21-1,2.84-.17a5.91,5.91,0,0,0-2.14-3.75.25.25,0,0,1,.32-.38,6.24,6.24,0,0,1,2.33,4.42l.24.16c4.67,3.25,3.66,8.75,3.65,8.81A.26.26,0,0,1,299.61,203.08ZM294,193.71a1.29,1.29,0,0,0-1,.42,2,2,0,0,0-.16,2.31c.34.41.83.23,1.17,0a2.82,2.82,0,0,0,1.46-2.27A3,3,0,0,0,294,193.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.1,211.45a12,12,0,0,1-11.59-8.54.25.25,0,0,1,.16-.32.25.25,0,0,1,.31.16,11.6,11.6,0,0,0,11.37,8.19.24.24,0,0,1,.26.24.25.25,0,0,1-.23.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.75,230a.25.25,0,0,1-.24-.2.24.24,0,0,1,.2-.29c5.37-1,8.4-6.69,8.43-6.74a.25.25,0,0,1,.34-.11.25.25,0,0,1,.1.34c-.12.24-3.16,5.95-8.78,7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.88,195.52a2.19,2.19,0,0,1-.89-.19,2.71,2.71,0,0,1-1.5-1.89,10.3,10.3,0,0,0-2.4,1.9.25.25,0,0,1-.35,0,.26.26,0,0,1,0-.36,10.63,10.63,0,0,1,2.66-2.06,8.46,8.46,0,0,1,.21-3.28.24.24,0,0,1,.3-.18.25.25,0,0,1,.19.29,8.47,8.47,0,0,0-.22,2.95,3.81,3.81,0,0,1,1.23-.26,2.4,2.4,0,0,1,1.85.75,1.27,1.27,0,0,1,.33,1.67A1.66,1.66,0,0,1,337.88,195.52Zm-1.93-2.3a2.31,2.31,0,0,0,1.24,1.66,1.44,1.44,0,0,0,1.67-.28c.2-.29.1-.66-.28-1a2,2,0,0,0-1.48-.61A3.44,3.44,0,0,0,336,193.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.23,202.47a.26.26,0,0,1-.23-.15c0-.06-2.17-5.48,3-11.65a.25.25,0,1,1,.38.32c-4.94,5.93-2.92,11.08-2.89,11.14a.25.25,0,0,1-.14.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,231.79a.24.24,0,0,1-.24-.2c-.86-4.27-6.85-5.9-6.91-5.92a.25.25,0,1,1,.13-.48c.26.07,6.35,1.72,7.27,6.3a.26.26,0,0,1-.2.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.48,316.91c-11-4.78-12.32-17.82-12.32-17.82a17.67,17.67,0,0,1,9,.73C375.31,305,376.43,310.66,377.48,316.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.84,278.05c15.52-12.54,33.87-30.27,38.7-50.12.08.35.36,1.22.59,1.25s-.09-.34-.57-.76c-10.85-7.61-36.66-9.25-50.63-10.74l-.6-12c17.59-2.5,40.74-3.83,57.6,2.71,10.73,4.32,17.52,13.13,14.83,25.37-4.69,24.82-22.69,45.46-41.64,60.87l-2,1.5-1,.75-1.14.83-14.17-19.67Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.89,278s23.69-19.5,32.11-31.83l19.41,24.08L376.1,310.46s-10.78-2.44-16.9-12.1A36.87,36.87,0,0,1,353.89,278Z",
    style: {
      fill: "#FF5733"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.86,384.1c-2.8-53.3,12.7-88.43,26.19-108.52,14.74-21.94,30.09-31.08,30.73-31.46l3.54,6-1.77-3,1.78,3c-.15.08-14.84,8.91-28.7,29.67-12.79,19.17-27.47,52.75-24.78,103.9Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.86,384.1c-2.8-53.3,12.7-88.43,26.19-108.52,14.74-21.94,30.09-31.08,30.73-31.46l3.54,6-1.77-3,1.78,3c-.15.08-14.84,8.91-28.7,29.67-12.79,19.17-27.47,52.75-24.78,103.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163,250.36l-3.74-5.92.54-.33,3.51,6.06-1.76-3,1.76,3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.6,377.48l0-1,7-.15,0,1Zm-.07-7.11v-1l7,.06v1Zm7.14-6.86-7-.25,0-1,7,.29Zm.36-6.87-7-.49.07-1,7,.52Zm.6-6.86-7-.72.11-1,7,.77Zm.84-6.81-6.93-1,.15-1,6.92,1Zm1.09-6.78L105.67,335l.19-1,6.88,1.28Zm1.36-6.73L107.08,328l.23-1,6.82,1.56Zm1.62-6.66L108.78,321l.26-1,6.75,1.84Zm1.9-6.57-6.68-2.09.31-1,6.67,2.13Zm2.19-6.48-6.58-2.39.35-1,6.56,2.43Zm2.48-6.38-6.47-2.68.4-.95,6.44,2.73Zm2.76-6.25-6.33-3,.44-.93,6.31,3Zm3.07-6.1-6.18-3.29.49-.91,6.15,3.35Zm3.36-5.93-6-3.61.53-.88,6,3.65Zm3.66-5.75-5.8-3.92.57-.84,5.78,3.95Zm4-5.55-5.58-4.23.62-.81,5.55,4.26Zm4.25-5.32L137.83,264l.67-.78,5.3,4.56Zm4.54-5.06-5.07-4.82.72-.75,5,4.88Zm4.83-4.76-4.75-5.14.76-.7,4.7,5.18Zm5.11-4.41-4.37-5.47.82-.65,4.31,5.52Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "102.86 384.1 102.83 383.58 109.83 383.25 109.85 383.69 102.86 384.1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M172,228.05a13.68,13.68,0,0,0-19.17,12l7.51,16.52,11.64-7.32L183.58,242Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,228.05a13.68,13.68,0,0,0-19.17,12l7.51,16.52,11.64-7.32L183.58,242Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,247c-3.06-4.86-8.91-6.36-10.54-6.69l-.08,0-.36-.07h0c-3.5-.52-9.17,1.17-14.78,4.69s-9.58,7.91-10.63,11.28l0,0s0,.13-.1.36l0,.07c-.41,1.62-1.59,7.53,1.46,12.4h0c2.5,4,12.38,2.27,22.07-3.82S197.48,251,195,247Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.89,269.06c2.5,4,12.38,2.27,22.07-3.82S197.48,251,195,247s-12.39-2.27-22.08,3.82S157.38,265.08,159.89,269.06Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18,247.49c2.16,3.44-3.59,10.93-12.84,16.75s-18.5,7.75-20.67,4.32c-1.29-2.07.28-5.61,3.77-9.38a48.93,48.93,0,0,1,19.66-12.35C189,245.31,192.89,245.43,194.18,247.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.31,247.13a11.62,11.62,0,1,1-19.68,12.37l-.19-.32a48.93,48.93,0,0,1,19.66-12.35C184.17,246.92,184.24,247,184.31,247.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.61,395.85v-6.67a6.41,6.41,0,0,0-6.41-6.41H86.67a6.41,6.41,0,0,0-6.41,6.41v6.67Z",
    style: {
      fill: "#FF5733"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.26,
    y: 392.4,
    width: 52.35,
    height: 3.45
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mugs--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.79,353.26a9.29,9.29,0,0,0,8.6,9.86l1.34.08.28,0,.66,0,0-.52.14-2.06-2.12-.14-.16,0a6.67,6.67,0,0,1-6.18-7.08l.16-2.42a1.47,1.47,0,0,1,1.56-1.34l2.64.18,3.22.22.18-2.6-3.54-.24-2.32-.16A4.06,4.06,0,0,0,81,350.86Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.79,353.26a9.29,9.29,0,0,0,8.6,9.86l1.34.08.28,0,.66,0,0-.52.14-2.06-2.12-.14-.16,0a6.67,6.67,0,0,1-6.18-7.08l.16-2.42a1.47,1.47,0,0,1,1.56-1.34l2.64.18,3.22.22.18-2.6-3.54-.24-2.32-.16A4.06,4.06,0,0,0,81,350.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.57,346v.24c0,.32,0,.64,0,1,0,.9.06,1.78.14,2.62a40.89,40.89,0,0,0,2,10.68A16.13,16.13,0,0,0,91,363.1l.06.12a5.08,5.08,0,0,0,2.42,2.24h0a2.33,2.33,0,0,0,.74.16l12,.82c1.62.12,3.24-1.24,4.68-3.72A27.71,27.71,0,0,0,113,358a58.47,58.47,0,0,0,2.38-9.82l0-.22Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.57,346v.24c0,.32,0,.64,0,1,0,.9.06,1.78.14,2.62a40.89,40.89,0,0,0,2,10.68A16.13,16.13,0,0,0,91,363.1l.06.12a5.08,5.08,0,0,0,2.42,2.24h0a2.33,2.33,0,0,0,.74.16l12,.82c1.62.12,3.24-1.24,4.68-3.72A27.71,27.71,0,0,0,113,358a58.47,58.47,0,0,0,2.38-9.82l0-.22Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.73,363.2l.28,0a5.08,5.08,0,0,0,2.42,2.24h0c4.84-.48,12-1.72,17.38-2.74A27.71,27.71,0,0,0,113,358c-4,.44-14.7,1.84-21.26,4.74-.26.12-.52.22-.76.36A1.07,1.07,0,0,0,90.73,363.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.42,376.5l-2.26.35-.4-2.57,2.26-.35a6.66,6.66,0,0,0,5.54-7.59l-.37-2.38a1.46,1.46,0,0,0-1.66-1.21l-5.8.91-.4-2.57,5.8-.91a4.05,4.05,0,0,1,4.62,3.38l.38,2.38A9.27,9.27,0,0,1,114.42,376.5Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.55,366.35a6.64,6.64,0,0,1-5.54,7.58l-.18,0-2.08.34L112,376l.14.84.64-.1,1.62-.24a.58.58,0,0,0,.18,0A9.27,9.27,0,0,0,122.13,366l-.38-2.38a4,4,0,0,0-4.62-3.38l-2.3.36-3.5.54.4,2.56,3.18-.5,2.62-.4a1.46,1.46,0,0,1,1.66,1.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,379.42,98,381.27c-3.65.57-8-6.56-10.74-17.41l-.05-.22,27.55-4.3,0,.23C115.52,370.73,113.5,378.85,109.85,379.42Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.21,363.65l.06.2a53.29,53.29,0,0,0,3.82,10.88c2.22,4.4,4.7,6.88,6.9,6.54l11.86-1.86c1.16-.18,2.16-1.1,2.94-2.66a4.79,4.79,0,0,0,.26-.56,13.91,13.91,0,0,0,.78-2.24,40.3,40.3,0,0,0,1.08-10.8c0-.84,0-1.7-.08-2.6,0-.32,0-.64-.06-1l0-.22Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.09,374.73c2.22,4.4,4.7,6.88,6.9,6.54l11.86-1.86c1.16-.18,2.16-1.1,2.94-2.66l1.62-.24a.58.58,0,0,0,.18,0c-.48-.1-1-.18-1.54-.28l-1-.18C106.35,375.09,98,374.07,91.09,374.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6,393.38h2.29v-2.6H92.6A6.65,6.65,0,0,1,86,384.14v-2.41a1.45,1.45,0,0,1,1.45-1.45h5.87v-2.6H87.41a4.06,4.06,0,0,0-4,4.05v2.41A9.25,9.25,0,0,0,92.6,393.38Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6,393.38h2.29v-2.6H92.6A6.65,6.65,0,0,1,86,384.14v-2.41a1.45,1.45,0,0,1,1.45-1.45h5.87v-2.6H87.41a4.06,4.06,0,0,0-4,4.05v2.41A9.25,9.25,0,0,0,92.6,393.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.56,395.56h12c3.7,0,6.94-7.71,7.92-18.85l0-.22H89.62l0,.22C90.62,387.85,93.87,395.56,97.56,395.56Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.56,395.56h12c3.7,0,6.94-7.71,7.92-18.85l0-.22H89.62l0,.22C90.62,387.85,93.87,395.56,97.56,395.56Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8,346.88c1.19.09.89,4.16,1.68,4.85s1.09-3.66,2.08-3.36,2.11,1.14,3.09-1Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.34,363.4s.59,4.15,1.28,4.2.15-3.51,1.11-3.21,2.12-1.62,2.12-1.62Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.88,388.11v5.57c0,1.43,1.69,2,3.1,2H253.35c1.43,0,3.15-.58,3.15-2v-5.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.88,388.11v5.57c0,1.43,1.69,2,3.1,2H253.35c1.43,0,3.15-.58,3.15-2v-5.57Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.88,388.11v5.57c0,1.43,1.69,2,3.1,2h73.46c1.42,0,3.12-.58,3.12-2v-5.57Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.25,330.24l13.26,60.14a4.51,4.51,0,0,0,4.3,3.42h72.43A2.93,2.93,0,0,0,213,390l-13.25-59.68c-.44-2-2.35-2.94-4.3-2.94H123C121,327.4,119.82,328.28,120.25,330.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.25,330.24l13.26,60.14a4.51,4.51,0,0,0,4.3,3.42h70a2.93,2.93,0,0,0,2.74-3.78l-13.26-59.68c-.43-2-2.36-2.94-4.3-2.94H123C121,327.4,119.82,328.28,120.25,330.24Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,360.81v0c0,5.14,5.52,9.33,9.56,9.33s6.45-4.19,5.3-9.33-5.18-9.16-9.14-9.32c1.15,5.15-1.32,9.32-5.35,9.32A1.79,1.79,0,0,1,156,360.81Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.26,
    y: 397.62,
    width: 362.11,
    height: 17.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.26,
    y: 397.62,
    width: 362.11,
    height: 17.94,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.33,
    y: 395.89,
    width: 373.98,
    height: 6.94,
    rx: 2.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.33,
    y: 395.89,
    width: 373.98,
    height: 6.94,
    rx: 2.02,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--books-2--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.61,
    y: 357.23,
    width: 47.6,
    height: 11.22,
    transform: "translate(756.82 725.69) rotate(180)",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.61,
    y: 357.23,
    width: 47.6,
    height: 11.22,
    transform: "translate(756.82 725.69) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.8,356.2h37.29a6.65,6.65,0,0,1,0,13.29H383.8v-2.43h5.67a4.22,4.22,0,0,0,0-8.43H383.8Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.8,356.2h37.29a6.65,6.65,0,0,1,0,13.29H383.8v-2.43h5.67a4.22,4.22,0,0,0,0-8.43H383.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.18,356.2h37.29a6.65,6.65,0,0,1,0,13.29H352.18v-2.43h37.29a4.22,4.22,0,0,0,0-8.43H352.18Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.18,356.2h37.29a6.65,6.65,0,0,1,0,13.29H352.18v-2.43h37.29a4.22,4.22,0,0,0,0-8.43H352.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 375.27,
    y: 343.95,
    width: 47.6,
    height: 11.22,
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.27,
    y: 343.95,
    width: 47.6,
    height: 11.22,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.68,342.92H356.4a6.64,6.64,0,1,0,0,13.28h37.28v-2.43H388a4.21,4.21,0,1,1,0-8.42h5.66Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.68,342.92H356.4a6.64,6.64,0,1,0,0,13.28h37.28v-2.43H388a4.21,4.21,0,1,1,0-8.42h5.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M425.3,342.92H388a6.64,6.64,0,0,0,0,13.28H425.3v-2.43H388a4.21,4.21,0,1,1,0-8.42H425.3Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M425.3,342.92H388a6.64,6.64,0,0,0,0,13.28H425.3v-2.43H388a4.21,4.21,0,1,1,0-8.42H425.3Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 344.83,
    y: 370.52,
    width: 47.6,
    height: 11.22,
    transform: "translate(737.27 752.26) rotate(180)",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.83,
    y: 370.52,
    width: 47.6,
    height: 11.22,
    transform: "translate(737.27 752.26) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,369.49h37.28a6.64,6.64,0,1,1,0,13.28H374v-2.43h5.66a4.21,4.21,0,0,0,0-8.42H374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374,369.49h37.28a6.64,6.64,0,1,1,0,13.28H374v-2.43h5.66a4.21,4.21,0,0,0,0-8.42H374Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.4,369.49h37.29a6.64,6.64,0,0,1,0,13.28H342.4v-2.43h37.29a4.21,4.21,0,0,0,0-8.42H342.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.4,369.49h37.29a6.64,6.64,0,0,1,0,13.28H342.4v-2.43h37.29a4.21,4.21,0,0,0,0-8.42H342.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 374.07,
    y: 383.8,
    width: 47.6,
    height: 11.22,
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.07,
    y: 383.8,
    width: 47.6,
    height: 11.22,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.11,382.77H386.82a6.65,6.65,0,0,0,0,13.29h37.29v-2.43H386.82a4.22,4.22,0,0,1,0-8.43h37.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.48,382.77H355.2a6.65,6.65,0,0,0,0,13.29h37.28v-2.43h-5.66a4.22,4.22,0,0,1,0-8.43h5.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.11,382.77H386.82a6.65,6.65,0,0,0,0,13.29h37.29v-2.43H386.82a4.22,4.22,0,0,1,0-8.43h37.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 349.03,
    y: 330.66,
    width: 47.6,
    height: 11.22,
    transform: "translate(745.66 672.55) rotate(180)",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.03,
    y: 330.66,
    width: 47.6,
    height: 11.22,
    transform: "translate(745.66 672.55) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6,342.92h37.28a6.65,6.65,0,1,0,0-13.29H346.6v2.43h37.28a4.22,4.22,0,1,1,0,8.43H346.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,342.92h37.29a6.65,6.65,0,0,0,0-13.29H378.22v2.43h5.66a4.22,4.22,0,1,1,0,8.43h-5.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.6,342.92h37.28a6.65,6.65,0,1,0,0-13.29H346.6v2.43h37.28a4.22,4.22,0,1,1,0,8.43H346.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.83 372.99 379.38 373.36 344.83 373.74 344.83 372.99"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.83 374.83 367.81 375.21 344.83 375.58 344.83 374.83"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.83 376.68 382.61 377.05 344.83 377.43 344.83 376.68"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.83 378.52 377.43 378.89 344.83 379.27 344.83 378.52"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.61 359.7 389.16 360.08 354.61 360.45 354.61 359.7"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.61 361.55 377.59 361.92 354.61 362.3 354.61 361.55"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.61 363.39 392.38 363.77 354.61 364.14 354.61 363.39"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.61 365.24 387.2 365.61 354.61 365.99 354.61 365.24"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.92 333.13 383.48 333.51 348.92 333.88 348.92 333.13"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.92 334.98 371.9 335.35 348.92 335.73 348.92 334.98"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.92 336.82 386.7 337.2 348.92 337.57 348.92 336.82"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.92 338.67 381.52 339.04 348.92 339.42 348.92 338.67"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.58 392.6 387.03 392.22 421.58 391.85 421.58 392.6"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.58 390.75 398.6 390.38 421.58 390 421.58 390.75"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.58 388.91 383.81 388.54 421.58 388.16 421.58 388.91"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.58 387.07 388.98 386.69 421.58 386.32 421.58 387.07"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.88 352.7 388.32 352.32 422.88 351.95 422.88 352.7"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.88 350.86 399.9 350.48 422.88 350.11 422.88 350.86"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.88 349.01 385.1 348.64 422.88 348.26 422.88 349.01"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.88 347.17 390.28 346.79 422.88 346.42 422.88 347.17"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book-1--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.06,389.08s-13.8-6.93-21.41-7.13H257.86l4.4,13.76L293,394.64l56.76-.83Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.06,389.08s-13.8-6.93-21.41-7.13H257.86l4.4,13.76L293,394.64l56.76-.83Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,389.76s8.09-6.73,17.89-7.71,13.23,6.72,13.23,6.72,4.66-6.41,12-6.81S304,389.08,304,389.08l-1.25,4.73-63.46.93Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,389.76s8.09-6.73,17.89-7.71,13.23,6.72,13.23,6.72,4.66-6.41,12-6.81S304,389.08,304,389.08l-1.25,4.73-63.46.93Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.06 389.08 350.81 390.01 350.65 390.6 349.79 393.81 302.7 393.81 303.24 391.76 303.42 391.14 303.96 389.08 351.06 389.08",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M302.7,389.64a81.06,81.06,0,0,0-8.37-3.14,38.86,38.86,0,0,0-8.67-1.9,17.26,17.26,0,0,0-8.54,1.76,33.91,33.91,0,0,0-7.47,4.72l-.24.19-.2-.23a21.76,21.76,0,0,0-6.37-5A14.07,14.07,0,0,0,259,384.7a12.12,12.12,0,0,0-4,0,35.85,35.85,0,0,0-7.83,2.49,71.74,71.74,0,0,0-7.43,3.62A74.07,74.07,0,0,1,247,387a36,36,0,0,1,7.87-2.68,12.33,12.33,0,0,1,4.2-.11,15,15,0,0,1,4,1.35,22.25,22.25,0,0,1,6.59,5.14l-.44,0a33.89,33.89,0,0,1,7.64-4.78,17.54,17.54,0,0,1,8.82-1.73,40.11,40.11,0,0,1,8.73,2.09A79.62,79.62,0,0,1,302.7,389.64Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240.22,391.44a56.22,56.22,0,0,1,7.16-2.74,36.35,36.35,0,0,1,7.54-1.49,21.88,21.88,0,0,1,7.68.76,23.23,23.23,0,0,1,7,3.23l-.32,0a48.47,48.47,0,0,1,7.83-2.83,24.26,24.26,0,0,1,8.26-1,60.92,60.92,0,0,1,8.2,1.33q4,.94,8,2.15c-2.67-.7-5.36-1.32-8.07-1.84a57.85,57.85,0,0,0-8.16-1.15,24.66,24.66,0,0,0-8.08,1,51.18,51.18,0,0,0-7.71,2.83l-.17.07-.15-.1a22.22,22.22,0,0,0-6.81-3.18,22.6,22.6,0,0,0-7.5-.84,36.86,36.86,0,0,0-7.49,1.31A57.66,57.66,0,0,0,240.22,391.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243.4,391.44a53.64,53.64,0,0,1,13.07-1.33,50,50,0,0,1,6.58.49,54.82,54.82,0,0,1,6.47,1.28h-.13c2.45-.44,4.92-.72,7.39-1s4.94-.43,7.43-.51,5-.05,7.44.08a58.5,58.5,0,0,1,7.37,1,72.45,72.45,0,0,0-14.79-.55,131.82,131.82,0,0,0-14.73,1.58h-.14a53.25,53.25,0,0,0-6.39-1.32,61.5,61.5,0,0,0-6.51-.59,59.65,59.65,0,0,0-6.55.1A49.21,49.21,0,0,0,243.4,391.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "350.81 390.01 350.65 390.6 305.52 390.31 350.81 390.01"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "346.44 391.45 303.24 391.76 303.42 391.14 346.44 391.45"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M267.66,393s.24-3.83,2-4.18,1.61,4.18,1.61,4.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.54,
    y: 392.17,
    width: 117.63,
    height: 3.72,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.54,
    y: 392.17,
    width: 117.63,
    height: 3.72,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.13,
    y: 392.17,
    width: 47.05,
    height: 3.72,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-balls--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.05,399.58l-3-8.12,3-6.54h5.8l5.64-6.78h7.84c1.48,0,8,4.78,8,4.78s-.52,4.74,0,5.3,3.33,3.24,3.33,3.24l-2.35,2V398l-1,1.81-8-.5a5.45,5.45,0,0,0-3.35,0c-2,.57-3.55,3.33-5,2.65S340.05,399.58,340.05,399.58Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,391.47l-2.34,2V398l-1,1.82-8-.51a5.36,5.36,0,0,0-3.35,0c-2,.58-3.55,3.33-5,2.66s-10.94-2.39-10.94-2.39l-3-8.1,3-6.55h5.8l5.64-6.78h7.84c1.47,0,8,4.77,8,4.77a25.4,25.4,0,0,0-.11,5,.78.78,0,0,0,.11.27C367.85,388.78,370.66,391.47,370.66,391.47Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.21,388l-2.27-5-4.22,6.53-3-1.36v-6.15l-6.16,2.37.88,5.14-1.84,4-7.31-6.56-1.76,4.72-4.48-.14,3-6.55h5.8l5.64-6.78h7.84c1.47,0,8,4.77,8,4.77A25.4,25.4,0,0,0,367.21,388Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05,399.57l3.63-.87v-8.05l7.1,6,4-9.25,2.17,3.61,4.75.45,3-3.09,1.58,1.57-1.7,3.07,1.7,1.22,2.06-.79L366,395l-2-1.16-2.28-1.59-5.4-.82L354.43,394l1.68,1.65-.17-2.63,4.05,4.86,1.7-2.84-2.7-.52,3.28-.07.41.9-2.4,3s-4.17-1.71-3.93-1.72-4.16,3.91-4.16,3.91l-5.4-1.87-.06-4.4-2.17,5-4.51.48",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,392.22v0l-.2.1-.52.32a2,2,0,0,0-.3.17l-.67.43a1.59,1.59,0,0,0-.3.18l-.66.42c-.56.34-1.17.72-1.75,1.11-.12.08-.25.14-.36.23s-.47.31-.69.46l-.34.22a14,14,0,0,0-2.27,1.71.86.86,0,0,1-.27.21.52.52,0,0,1-.18,0v0h-.34a5.88,5.88,0,0,1-1.75-.67,6.87,6.87,0,0,0-2.6-.86,3.81,3.81,0,0,0-2.75.92l-6.37,2.7-1.52-1.53-1.76-4.5-2.7-1.31s.32-.85.66-1.81c.09-.22.17-.47.27-.7a3,3,0,0,1,.12-.36c.12-.34.23-.64.3-.87l.14-.4a.41.41,0,0,0,0-.11c0-.05,0-.12,0-.19a10.3,10.3,0,0,0-.57-1.67c-.28-.69-.61-1.43-.89-2-.08-.19-.17-.37-.25-.53a.16.16,0,0,0-.05-.1c-.13-.28-.22-.47-.27-.56l0,0h0v0c.21-.4,3.52-6.54,4.7-6.91l6.45-2.16,1.64,1.16,5.62,4,4.77-1.59,5,5.66Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.4,392.23l-.19.13-.52.32a2,2,0,0,0-.3.17l-.67.43a1.59,1.59,0,0,0-.3.18q-.31.18-.66.42c-.56.34-1.17.72-1.75,1.11-.12.08-.25.14-.36.23s-.47.31-.69.46l-.34.22a14,14,0,0,0-2.27,1.71.86.86,0,0,1-.27.21.52.52,0,0,1-.18,0v0h-.34a5.88,5.88,0,0,1-1.75-.67,6.87,6.87,0,0,0-2.6-.86,3.81,3.81,0,0,0-2.75.92l-6.37,2.7-1.52-1.53-1.76-4.5-2.7-1.31s.32-.85.66-1.81c.09-.22.17-.47.27-.7a3,3,0,0,1,.12-.36c.11-.34.23-.64.3-.87l.14-.4a.41.41,0,0,0,0-.11c0-.05,0-.12,0-.19a10.3,10.3,0,0,0-.57-1.67c-.28-.69-.61-1.43-.89-2-.08-.19-.17-.37-.25-.53a.16.16,0,0,0-.05-.1c-.13-.28-.22-.47-.27-.56s0,0,0,0h0c.21-.4,3.52-6.54,4.7-6.91l6.45-2.16,1.64,1.16,5.62,4,4.76-1.59,5,5.64Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,392.22h0l-4.67-.62,2.11-8.22-4.67,1.2-2.5-4.22-4.75-1.72,4.33,5.42-2.81,3.59-9.36-8,1.83,6.22-8.37-2.65c.21-.4,3.52-6.54,4.7-6.91l6.45-2.16,1.64,1.16,5.62,4,4.77-1.59,5,5.66Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.21,396.35a3.81,3.81,0,0,0-2.75.92l-6.37,2.7-1.52-1.53-1.76-4.5-2.7-1.31s.32-.85.66-1.81c.09-.22.17-.47.27-.7a3,3,0,0,1,.12-.36c.11-.34.23-.64.3-.87l.14-.4,9.49,1.08-.26-2.62,5,3.92-5.12,1.28.21,2.32,3.36,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,397.87h-.28a5.88,5.88,0,0,1-1.75-.67,6.87,6.87,0,0,0-2.6-.86l4.56-3L212,389l3.69-.38s-1.6,4.65-1.33,4.76S212.58,397.77,212.84,397.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,389.22v0l.06.12.16.35a1.23,1.23,0,0,1,.1.2l.2.46a.72.72,0,0,1,.09.2l.2.45c.17.38.36.79.52,1.21a1.89,1.89,0,0,1,.11.25c.07.15.14.32.2.47l.1.24a9,9,0,0,1,.59,1.7.38.38,0,0,0,.07.21.5.5,0,0,0,.07.08h0a.42.42,0,0,0,.15.11,3.6,3.6,0,0,0,1.15.27,4.44,4.44,0,0,1,1.67.47,2.41,2.41,0,0,1,1.11,1.45l2.38,3.67,1.34-.27,2.51-1.73,1.88.27.29-1.18c0-.15.08-.31.11-.47a1.55,1.55,0,0,0,.07-.23c0-.22.1-.41.15-.56s.05-.2.07-.26a.15.15,0,0,1,0-.06,1,1,0,0,0,.07-.09,6.7,6.7,0,0,1,.89-.67c.39-.27.83-.54,1.19-.76.1-.07.22-.13.32-.19s0,0,.06,0l.33-.2h0c0-.28.46-4.67,0-5.28L185.88,386l-1.28,0-4.35.1-1.94-2.52-4.61,1.2Z",
    style: {
      fill: "#FF5733"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.21,389.23a1.11,1.11,0,0,1,0,.13l.16.35a1.23,1.23,0,0,1,.1.2l.2.46a.72.72,0,0,1,.09.2,4.68,4.68,0,0,1,.2.45c.17.38.36.79.52,1.21a1.89,1.89,0,0,1,.11.25c.07.15.14.32.2.47l.1.24a9,9,0,0,1,.59,1.7.38.38,0,0,0,.07.21.5.5,0,0,0,.07.08h0a.42.42,0,0,0,.15.11,3.6,3.6,0,0,0,1.15.27,4.44,4.44,0,0,1,1.67.47,2.41,2.41,0,0,1,1.11,1.45l2.38,3.67,1.34-.27,2.51-1.73,1.88.27.29-1.18c0-.15.08-.31.11-.47a1.55,1.55,0,0,0,.07-.23c.06-.21.1-.41.15-.56s.05-.2.07-.26a.15.15,0,0,1,0-.06,1,1,0,0,0,.07-.09,6.7,6.7,0,0,1,.89-.67c.39-.27.83-.54,1.19-.76.1-.07.22-.13.32-.19s0,0,.06,0l.33-.2h0c0-.28.46-4.67,0-5.28L185.88,386l-1.28,0-4.35.11-1.94-2.52-4.61,1.19Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,389.22h0l2.67,1.32,1.8-5.05,2,2.28,2.8-1.33,3.1.78-4.19,1.31.2,2.88,7.73-.88-3.15,2.61,5.32,1.57c0-.28.46-4.67,0-5.28L185.88,386l-1.28,0-4.35.1-1.94-2.52-4.61,1.2Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.67,396.05a2.41,2.41,0,0,1,1.11,1.45l2.38,3.67,1.34-.27,2.51-1.73,1.88.27.29-1.18c0-.15.08-.31.11-.47a1.55,1.55,0,0,0,.07-.23c.06-.21.1-.41.15-.56s.05-.2.07-.26L180.22,394l1.06-1.28-4,.28,2.22,2.48-.92,1.14-1.75-1.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,395.2a.42.42,0,0,0,.15.11,3.6,3.6,0,0,0,1.15.27,4.44,4.44,0,0,1,1.67.47l-1.35-3.16,2-2.06-1.79-1.5a17.74,17.74,0,0,1-1,3C173.33,392.25,172.87,395.25,172.7,395.2Z",
    style: {
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentstressRafiki);
export default __webpack_public_path__ + "static/media/Student stress-rafiki.0e16aec7baec7e2ada9bfa73ff0a8028.svg";
export { ForwardRef as ReactComponent };